import { useContext } from "react";
import { GlobalContext } from "../../../../global/context/Provider";
import Layout from "../../../../global/component/Genericos/Layout/Layout";
import Table from "../../../../global/component/Genericos/Table/Table";
import { configTable } from "./configTable";
import { ContainerTbl, TableContainer } from "./localStyle";
import camelize from "../../../../global/utils/camelize";

const Videotutoriales = () => {
    const { authState } = useContext(GlobalContext);


    return (
        <Layout  positionSidebar={6}>

            <ContainerTbl>
                <h1>Tabla de Videotutoriales</h1>
                <TableContainer>
                    <Table configTable={configTable}/>
                </TableContainer>
            </ContainerTbl>
        </Layout>
    )
}

export default Videotutoriales;